import type { InferredEntity } from '@sites/entity-migrator';
import { createVersionedEntityWithDefaults } from '@sites/entity-migrator';

import { blockZeroV0Schema } from './v0';
import { blockZeroLegacySchema } from '../legacy/schema';
import { migrateLegacyZeroToV0 } from '../legacy/migration';

export const ZeroBlockEntitySchema = createVersionedEntityWithDefaults({
    versionMap: {
        0: { schema: blockZeroV0Schema },
    },
    latestVersion: 0,
    legacy: [{ name: 'web', schema: blockZeroLegacySchema, up: migrateLegacyZeroToV0 }],
});

export type ZeroBlock = InferredEntity<typeof ZeroBlockEntitySchema>;
